import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { DAY_OFF_OPTIONS } from '@/pages/Onboarding/options/DayOff/DAY_OFF_OPTIONS';
import { getDayOffTitleById } from '@/pages/Onboarding/options/DayOff/utils/getDayOff';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const DayOffScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'DayOff',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const dayOff = form.watch('day_off');

  const handleSelect = (option: OnbOptionType<LayoutDataType['day_off']>) => {
    form.setValue('day_off', option.id);
  };

  const handleNextStep = () => {
    const dayOffTitle = getDayOffTitleById(dayOff);
    userService.createOrUpdate({
      onboarding_data: {
        day_off: dayOffTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>How Does He Like To Spend His Day Off?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {DAY_OFF_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={dayOff === option.id}
              control={form.control}
              option={option}
              name="day_off"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!dayOff}
      />
    </OnboardingPage>
  );
};
